import React, { ReactNode } from 'react';
import { Button, Grow, Paper, Popper } from '@mui/material';
import { type SxProps, type Theme } from '@mui/material/styles';

export interface PopperButtonProps {
  buttonContent: (expanded: boolean) => ReactNode;
  children: ReactNode;

  top?: boolean;
}

const buttonExpandedSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  boxShadow: 4,
  borderColor: 'transparent',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  '&:hover': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'dark'
        ? theme.palette.grey[700]
        : theme.palette.grey[100],
  },
};

export const PopperButton = (props: PopperButtonProps) => {
  const { buttonContent, children, top } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      <Button
        sx={anchorEl != null ? buttonExpandedSx : undefined}
        onClick={handleClick}
        variant={'outlined'}
      >
        {buttonContent(anchorEl != null)}
      </Button>
      <Popper
        open={anchorEl != null}
        anchorEl={anchorEl}
        placement={top ? 'top-end' : 'bottom-end'}
        transition
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            timeout={350}
            style={{ transformOrigin: 'top right' }}
          >
            <Paper sx={{ borderTopRightRadius: 0, padding: 2 }} elevation={4}>
              {children}
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
